export default (element: HTMLElement) => {
  // eslint-disable-next-line no-void
  void element.offsetHeight;
};
